<!-- Slider main container -->
<div #swiperContainer class="swiper">
  <!-- Additional required wrapper -->
  <div class="swiper-wrapper">
    <!-- Slides -->
    <ng-content></ng-content>
  </div>

  <!-- If we need navigation buttons -->
  @if (navigation()) {
    <div class="navigation">
      <button (click)="slidePrevious$.next()" [disabled]="!loop() && !!swiper?.isBeginning" mat-icon-button>
        <ui-icon faName="chevron-left" faStyle="light"></ui-icon>
      </button>
      <button (click)="slideNext$.next()" [disabled]="!loop() && !!swiper?.isEnd" mat-icon-button>
        <ui-icon faName="chevron-right" faStyle="light"></ui-icon>
      </button>
    </div>
  }
</div>
